module.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}"


//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/postcss-loader/lib??ref--1-1!../ckeditor5-link/theme/link.css
// module id = 75
// module chunks = 0